import GalleryModal from "./gallery-modal/src/galleryModal";
import HotelRoomCard from "./hotel-room-card/src/hotelRoomCard";
import CustomSlider from "./custom-slider/src/customSlider";
import ImageGallery from "./image-gallery/src/imageGallery";
import ImageGalleryList from "./image-gallery-list/src/imageGalleryList";
import CustomNotification from "./notification/src/customNotification";
import ExternalReview from "./external-review/src/externalReview";
import ListExternalReviews from "./list-external-reviews/src/listExternalReviews";
import CallRequestCustomer from "./call-request-customer/src/callRequestCustomer";
import HotelRatingSummary from "./hotel-rating-summary/src/hotelRatingSummary";
import UserReview from "./user-review/src/userReview";
import ScrollingWrapper from "./scrolling-wrapper/src/scrollingWrapper";
import RatingSummary from "./rating-summary/src/ratingSummary";
import RoundedList from "./rounded-list/src/roundedList";
import HotelConditions from "./hotel-conditions/src/hotelConditions";
import TextDescription from "./text-description/src/textDescription";
import AlertMessages from "./alert-messages/src/alertMessages";
import CardMedia from "./card-media/src/cardMedia";
import TextCollapse from "./text-collapse/src/textCollapse";
import ComplementsFinalSummary from "./complements-final-summary/src/complementsFinalSummary";
import InfoSummaryExtended from "./info-summary-extended/src/infoSummaryExtended";
import CardIcon from "./card-icon/src/cardIcon";
import TabsMenu from "./tabs-menu/src/tabsMenu";
import FaqCard from "./faq-card/src/faqCard";
import BrandReviewList from "./brand-review-list/src/brandReviewList";

customElements.define('gallery-modal', GalleryModal);
customElements.define('hotel-room-card', HotelRoomCard);
customElements.define('custom-slider', CustomSlider);
customElements.define('image-gallery', ImageGallery);
customElements.define('image-gallery-list', ImageGalleryList);
customElements.define('custom-notification', CustomNotification);
customElements.define('external-review', ExternalReview);
customElements.define('list-external-reviews', ListExternalReviews);
customElements.define('call-request-customer', CallRequestCustomer);
customElements.define('hotel-rating-summary', HotelRatingSummary);
customElements.define('user-review', UserReview);
customElements.define('scrolling-wrapper', ScrollingWrapper);
customElements.define('rating-summary', RatingSummary);
customElements.define('rounded-list', RoundedList);
customElements.define('hotel-conditions', HotelConditions);
customElements.define('text-description', TextDescription);
customElements.define('alert-messages', AlertMessages);
customElements.define('card-media', CardMedia);
customElements.define('text-collapse', TextCollapse);
customElements.define('complements-final-summary', ComplementsFinalSummary);
customElements.define('info-summary-extended', InfoSummaryExtended);
customElements.define('card-icon', CardIcon);
customElements.define('tabs-menu', TabsMenu);
customElements.define('faq-card', FaqCard);
customElements.define('brand-review-list', BrandReviewList);
